export { default } from "./OrderItem-component";
